import React from 'react'
import styled from 'styled-components'
import CreateRatingForm from './createratingform'

const Styles = styled.div`
    max-width: 680px;
    margin: 24px auto;
    padding: 28px 32px;
    margin-bottom: 100px;
    background: #FFFFFFEE;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.08);

    @media (max-width: 480px) {
        margin: 0;
        border-radius: 0;
        box-shadow: none;
        padding: 20px 16px;
    }
`
export default function CreateRating() {
    return <Styles>
        {/* <h1 style={{textAlign: 'center'}}>Rate Your Pini</h1> */}
        {/* <hr></hr> */}
        <CreateRatingForm/>
    </Styles>
}